export const MISSION_URL = 'p/loyalty/missions/v1/';
export const AUTHENTICATED_MISSION_URL = 'r/loyalty/missions/v1/';

export const MISSION_FLAG_IMAGE_PATH = '/image/mission_flag.svg';
